import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=e0ae3ec8&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"
import style0 from "./tickets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports